import makeHttpRequest from "./makeHttpRequest";

export const downloadFile = async (url, fileName, params) => {
    const response = await makeHttpRequest({
        url,
        method: "GET",
        params,
        responseType: "blob",
    });

    const href = URL.createObjectURL(response.data);

    const anchorElement = document.createElement("a");

    anchorElement.href = href;
    anchorElement.download = fileName;

    document.body.appendChild(anchorElement);
    anchorElement.click();

    document.body.removeChild(anchorElement);
    URL.revokeObjectURL(href);
};
